import { render, staticRenderFns } from "./RequestItems.vue?vue&type=template&id=538404ab&scoped=true&"
import script from "./RequestItems.vue?vue&type=script&lang=js&"
export * from "./RequestItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538404ab",
  null
  
)

export default component.exports